import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'light',
    primary: { main: '#5e4671', dark: '#3f2a56', contrastText: '#ffffff' },
    secondary: { main: '#4d738a', dark: '#2d4156', contrastText: '#ffffff' },
    warning: { main: '#9a4d00', contrastText: '#ffffff' },
    background: { default: '#f3f5f5', paper: '#ffffff' },
    text: { primary: '#333333', secondary: '#59636a' },
    divider: '#d9d5dc',
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily:
      '"Bahnschrift", Aptos, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: {
      fontFamily: 'Baskerville, "Baskerville Old Face", Georgia, serif',
      fontWeight: 600,
      letterSpacing: '-0.025em',
    },
    h2: {
      fontFamily: 'Baskerville, "Baskerville Old Face", Georgia, serif',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: 'Baskerville, "Baskerville Old Face", Georgia, serif',
      fontWeight: 600,
    },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': { outline: '3px solid #005fcc', outlineOffset: 3 },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { border: '1px solid #d9d5dc', boxShadow: 'none' },
      },
    },
  },
});
